const CameraZone = ({ worldCenter, size }) => {
    return (
        <div
            style={{
                position: 'absolute',
                top: `${worldCenter.y - size.length / 2}px`,
                left: 0,
                height: `${size.length}px`,
                border: '1px solid black',
                width: '100%',
            }}
        />
    );
}

export default CameraZone